import api from '../../module_user/api/api';
const baseUrl = process.env.VUE_APP_API_URL;

export default {
    async authAccessCodeForCorporateSignup(data) {
        let response = await api.put(baseUrl + '/corporate-user/register-as-corporate', data);
        return response.data;
    },
    async authAccessCode(data) {
        let response = await api.put(baseUrl + '/corporate-user/register-code', data);
        return response.data;
    },
    async verifyUser(data) {
        let response = await api.put(baseUrl + '/corporate-user/verify', data);
        return response.data;
    },
    async getCorporateProgram(data) {
        let response = await api.get(baseUrl + `/corporate-program/get-programs?id=${data.id}&type=${data.type}`);
        return response.data;
    },
    async getTenantProgram(data) {
        let response = await api.get(baseUrl + `/corporate-program/get-tenant-programs?id=${data.id}`);
        return response.data;
    },
    async getTenantVideos(tenantId, page, perPage) {
        let response = await api.get(baseUrl + `/trainer/videos/${tenantId}?page=${page}&perPage=${perPage}`);
        return response.data;
    },
    async getSMBVideos(tenantId){
        let response = await api.get(baseUrl + `/trainer/smbvideos/${tenantId}`);
        return response.data;
    },
    async createProgramHistory({assignedId, type}) {
        const body = {assignedId, type: type || 'corporate'};
        let response = await api.put(baseUrl + `/tenant-program/record-assigned-program-start`, body);
        return response.data;
    },
    async deleteProgramHistory(program_id) {
        let response = await api.delete(baseUrl + `/corporate-program/user-program-history?id=${program_id}`);
        return response.data;
    },
    async getTrainerLeaderboard(name, limit){
        return api.get(baseUrl + `/trainer/leaderboard/${name}?limit=${limit}`);
    },
    async verifyPromoCode(data) {
        let response = await api.get(baseUrl + `/promo-code/validate/${data.promocode}`);
        return response.data;
    },
    async verifyEmailVerificationCode(data) {
        let response = await api.post(baseUrl + '/user-detail/verify-email', data);
        return response.data;
    },
    async resendEmailVerificationCode() {
        let response = await api.post(baseUrl + '/user-detail/resend-email-verification-code');
        return response.data;
    },
    async applyPromoCode(data) {
        let response = await api.post(baseUrl + '/promo-code/use', data);
        return response.data;
    },
    async updateNotificationStatus(data) {
        let response = await api.put(baseUrl + '/notification/update-status', data);
    },    
    async  getDashboardRanking(){
        let response = await api.get(baseUrl + "/corporate/dashboard-ranking/",);
        return response.data;
    },
    async getAssessmentProgram(){
         let response = await api.get(
           baseUrl + "/user-assessment"
         );
         return response.data;
    },
    async retakeAssessment(){
        let response = await api.post(
          baseUrl + "/user-assessment/retake"
        );
        return response.data;
    },
    async submitAssessment(){
        let response = await api.post(baseUrl + "/user-assessment");
        return response.data;
    }
}
